/* Vendored from the board kit on feat/board-kit-legend-scroll (b834d95, verifier-CONFIRMED, not yet on master).
 * Manifest Review needs the docked record and the top scroll rail now; when that branch lands, import this
 * from components/board instead and delete this copy. Kept byte-close to the kit on purpose. */
/**
 * Small per-viewer conveniences the kit remembers (a collapsed legend, a
 * collapsed panel section). Browser storage can be missing, blocked or
 * throwing (private windows, previews, cleared site data), so every read and
 * write is wrapped and the kit renders correctly without it. Nothing here is
 * shared state or a record: it is a remembered preference only.
 */

const PREFIX = 'emerge.board.';

export function readMemory<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeMemory(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* storage unavailable: the preference lasts for this view only */
  }
}

/** A stable storage-safe slug ("eMerge states" -> "emerge-states"). */
export function memorySlug(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'board';
}
